import React, { Suspense } from 'react'; // Importa o Suspense
import ReactDOM from 'react-dom/client';
import './index.css';
import Game from './Game';
import './i18n';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <Suspense fallback={<div className="loading-screen">Loading...</div>}>
        <Game />
      </Suspense>
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
  <React.StrictMode>
    {/* --- MUDANÇA AQUI: Envolve o jogo com o Suspense --- */}
    <Suspense fallback={<div className="loading-screen">Loading...</div>}>
      <Game />
    </Suspense>
  </React.StrictMode>
  );
}
